import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";

import { TooltipDescription } from "@app/analytics/components/ScrubberBar/styles";

import { Row, StackProps } from "@rui/Stack";

export const BlockGlyph = styled(Box)({
  height: "10px",
  width: "10px",
  borderRadius: "2px",
  marginRight: "4px",
});

export const MarkerGlyph = styled(Box)({
  height: "10px",
  width: "10px",
  borderRadius: "50%",
  marginRight: "4px",
  border: "2px solid",
});

export const AnnotationRow = styled((props: StackProps) => (
  <Row variant="left" {...props} />
))(({ theme }) => ({
  fontSize: "0.75rem",
  whiteSpace: "nowrap",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: 500,
  maxWidth: "100%",
  marginRight: "10px",
  width: "100%",
}));

export const AnnotationLabel = styled(Row)(({ theme }) => ({
  color: "white",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "16px",
  marginRight: theme.spacing(1),
}));

export const AnnotationDescription = styled(TooltipDescription)({
  color: "white",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "16px",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden",
});
